<template>
  <v-dialog v-model="dialogVisible" max-width="800" scrollable>
    <v-card class="selection-modal">
      <v-card-title class="selection-modal__header">
        <v-icon left>mdi-chart-line</v-icon>
        Select KPIs
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="selection-modal__subtitle">
        Choose from available KPIs or create a new one
        <v-btn color="primary" class="ml-4" @click="$emit('create-new')" small>
          <v-icon left>mdi-plus</v-icon>
          Create New KPI
        </v-btn>
      </div>

      <!-- Search Bar -->
      <div class="selection-modal__search">
        <v-text-field
          v-model="searchQuery"
          prepend-inner-icon="mdi-magnify"
          placeholder="Search KPIs..."
          outlined
          dense
          hide-details
          clearable
        ></v-text-field>
      </div>

      <v-divider></v-divider>

      <v-card-text class="selection-modal__content">
        <!-- Empty State -->
        <div v-if="filteredKpis.length === 0" class="empty-state">
          <v-icon size="64" color="grey">mdi-target-outline</v-icon>
          <p v-if="searchQuery">No KPIs match your search</p>
          <p v-else>No KPIs available</p>
        </div>

        <!-- KPIs -->
        <div class="kpis">
          <kpi-card
            v-for="kpi in filteredKpis"
            :key="kpi.id"
            :kpi="kpi"
            :is-selected="isSelected(kpi.id)"
            is-selectable
            @toggle="toggleKpi"
            class="kpi-card-wrapper"
          />
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="selection-modal__actions">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import KpiCard from "./KpiCard.vue";

export default {
  name: "KpiSelectionModal",

  components: {
    KpiCard,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    kpis: {
      type: Array,
      default: () => [],
    },
    selectedKpiIds: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["close", "toggle", "select", "create-new"],

  data() {
    return {
      searchQuery: "",
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("close", val);
      },
    },

    filteredKpis() {
      if (!this.searchQuery) {
        return this.kpis;
      }
      const query = this.searchQuery.toLowerCase();
      return this.kpis.filter(
        (kpi) =>
          kpi.name?.toLowerCase().includes(query) ||
          kpi.pillar?.toLowerCase().includes(query) ||
          kpi.unit?.toLowerCase().includes(query) ||
          kpi.description?.toLowerCase().includes(query)
      );
    },
  },

  methods: {
    close() {
      this.searchQuery = "";
      this.$emit("close", false);
    },

    isSelected(kpiId) {
      return this.selectedKpiIds.includes(kpiId);
    },

    toggleKpi(kpi) {
      this.$emit("toggle", kpi);
    },
  },

  watch: {
    value(newVal) {
      if (!newVal) {
        this.searchQuery = "";
      }
    },
  },
};
</script>

<style scoped>
.selection-modal {
  height: 80vh !important;
}

.selection-modal__header {
  background-color: var(--primaryColor);
  color: var(--backgroundColor) !important;
  align-items: center;
}

.selection-modal__subtitle {
  padding: 12px 16px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selection-modal__search {
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.02);
}

.selection-modal__content {
  max-height: 500px;
  overflow-y: auto;
  padding: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.empty-state p {
  margin: 16px 0;
  font-size: 1.1rem;
}

.kpis {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.kpi-card-wrapper {
  width: 100%;
}
</style>
